<template>
  <v-card flat class="card--outlined">
    <v-toolbar flat class="ma-0 pa-0">
      <div>
        <v-card-title class="ma-0 pa-0">
          <span class="headline">Inventario</span>
        </v-card-title>
        <v-card-subtitle class="ma-0 pa-0">
          <span class="grey--text">
            Configuración del inventario para el desarrollo
          </span>
        </v-card-subtitle>
      </div>
      <v-spacer></v-spacer>
      <v-btn
        outlined
        color="red"
        :loading="loading"
        :disabled="!inventory.length || !amenities.length"
        @click="handleDeleteInventory()"
      >
        Eliminar
      </v-btn>
    </v-toolbar>

    <v-card-text v-if="inventory">
      <InventoryTable :inventory="inventory" />
      <v-divider></v-divider>
      <AmenitiesTable :amenities="amenities" />
    </v-card-text>
  </v-card>
</template>
<script>
import { deleteDevelopmentInventory } from "../../../api/mntto/developments";

export default {
  name: "DevelopmentDetailInventory",
  components: {
    InventoryTable: () => import("./Properties.vue"),
    AmenitiesTable: () => import("./Amenities.vue")
  },
  props: {
    inventory: { type: Array },
    amenities: { type: Array }
  },
  data() {
    return {
      developmentId: this.$route.params.id,
      loading: false
    };
  },
  methods: {
    handleDeleteInventory() {
      this.$confirmation(
        "Eliminar inventario y amenidades",
        `Se eliminiran ${this.inventory.length} registros del inventario y ${this.amenities.length} registros de amenidades. ¿Desea continuar?`,
        () => this.deleteInventory(this.developmentId)
      );
    },
    async deleteInventory(id) {
      this.loading = true;
      await deleteDevelopmentInventory(id);

      this.$emit("update:inventory", {
        properties: [],
        amenities: []
      });
      this.loading = false;
    }
  }
};
</script>
